import axios from "axios";

export async function getRequisitionApproved(token:string, params:any): Promise<any> {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/requisicao/aprovacao/usuario`, {
        params,
        headers: {
            Authorization: 'Bearer ' + token
        }
        });
  
      return response.data; // Supondo que as requisições sejam retornados pelo backend
    } catch (error) {
      throw new Error('Falha na autenticação');
    }
}

export async function getRequisitionApprovedDashboard(token:string, params: any): Promise<any> {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_URL+`/requisicao/aprovacao/dashboard`, {
      params,
      headers: {
          Authorization: 'Bearer ' + token
      }
      });

    return response.data; // Supondo que as requisições sejam retornados pelo backend
  } catch (error) {
    throw new Error('Falha na autenticação');
  }
}